const TimeZoneOffset = () => {
  const timeZoneName = Intl.DateTimeFormat("en", {
    timeZoneName: "longOffset",
    timeZone: process.env.GATSBY_DEFAULT_TIMEZONE,
  })
    .formatToParts()
    .find((i) => i.type === "timeZoneName")?.value

  if (!timeZoneName) return ""
  const match = timeZoneName.match(/GMT([+-])(\d{2}):(\d{2})/)

  if (!match) return ""

  const [, sign, hours, minutes] = match
  return `${sign}${hours}${minutes}`
}

export default TimeZoneOffset
